import { Injectable } from "@angular/core";

interface PathLocation {
    id: PATHS;
    path: string;
    location: string;
    mainPath?: boolean;
};

export enum PATHS {
    ROOT = 'root',
    LOGIN = 'login',
    FORGOT = 'forgot',
    CHANGE = 'change',
    NOT_FOUND = '404',
    DASHBOARD = 'dashboard',
    ADMIN = 'admin',
    PROPERTY = 'property',
    FACILITY = 'facility',
    FINANCIAL = 'financial',
    UICOMPONENTS = 'uicomponents',
    CLREQUESTS = 'clrequests',
    RFQS = 'rfqs',
    CLOFFERS = 'cloffers',
    OFFERS = 'offers',
    CLORDERS = 'clorders',
    ORDERS = 'orders',
    LEADS = 'leads',
    CLIENTS = 'clients',
    CLIENTS_ADD = 'clients/add',
    CLIENTS_PLANNING = 'clients/planning',
    QUOTATIONS = 'quotations',
    STOCK = 'stock',
    QUALITIES = 'config/qualities',
    QUALITIES_ADD = 'config/qualities/add',
    QUALITIES_EDIT = 'config/qualities/',
    DIMENSIONS = 'config/dimensions',
    DIMENSIONS_ADD = 'config/dimensions/add',
    DIMENSIONS_EDIT = 'config/dimensions/',
    PRODUCTS = 'config/products',
    PRODUCTS_ADD = 'config/products/add',
    PRODUCTS_EDIT = 'config/products/',
    ALTERNATIVES = 'config/alternatives',
    ALTERNATIVES_ADD = 'config/alternatives/add',
    ALTERNATIVES_EDIT = 'config/alternatives/',
    ORGANISATIONS = 'config/organisations',
    ORGANISATIONS_ADD = 'config/organisations/add',
    ORGANISATIONS_EDIT = 'config/organisations/',
    AGENTS = 'config/agents',
    AGENTS_ADD = 'config/agents/add',
    AGENTS_EDIT = 'config/agents/',
    ADMIN_USERS = 'admin/users',
    ADMIN_USERS_ADD = 'admin/users/add',
    ADMIN_USERS_EDIT = 'admin/users/'
};

export enum Cookies {
    TOKEN = 'token'
}

export enum PROCESS_SERVICE_STATES {
    waiting = 'waiting',
    inProgress = 'in_progress',
    done = 'done'
};

export enum REQUEST_STATUSES {
    error = 1,
    success = 0
};

export enum ERRORS {
    malformedRequest = 'malformed_request'
};

export enum LOCAL_STORAGE_KEYS {
    token = 'token',
};

/**
 * Am decis sa declar toate pathurile copiilor fiecarei rute, pentru a putea accesa in mod direct fara alte verificari
 * Astfel, daca am nevoie de un path, pot sa il accesez direct din PATH_LOCATIONS.children[PATHS.LOGIN].path
 */
export type RootPath = PATHS.LOGIN | PATHS.DASHBOARD | PATHS.FORGOT | PATHS.CHANGE | PATHS.NOT_FOUND | PATHS.ADMIN | PATHS.PROPERTY | PATHS.FACILITY | PATHS.FINANCIAL | PATHS.UICOMPONENTS | PATHS.CLREQUESTS | PATHS.RFQS | PATHS.CLOFFERS | PATHS.CLORDERS | PATHS.OFFERS | PATHS.ORDERS | PATHS.LEADS | PATHS.CLIENTS | PATHS.QUOTATIONS | PATHS.STOCK;
/* type OtherPath = PATHS.LOGIN | PATHS.DASHBOARD; */

type PathLocationChildren = {
    /* [K in (RootPath | OtherPath)]: PathLocation | PathLocationWithChildren; */
    [K in RootPath]: PathLocation | PathLocationWithChildren;
};

interface PathLocationWithChildren extends PathLocation {
    children: PathLocationChildren;
}

export const EVENTS = {
    languageChanged: 'languageChanged',
};

export const PATH_LOCATIONS: PathLocationWithChildren = {
    id: PATHS.ROOT,
    path: '/',
    location: '/',
    children: {
        [PATHS.LOGIN]: {
            id: PATHS.LOGIN,
            path: `/${PATHS.LOGIN}`,
            location: `/${PATHS.LOGIN}`,
        },
        [PATHS.FORGOT]: {
            id: PATHS.FORGOT,
            path: `/${PATHS.FORGOT}`,
            location: `/${PATHS.FORGOT}`,
        },
        [PATHS.CHANGE]: {
            id: PATHS.CHANGE,
            path: `/${PATHS.CHANGE}`,
            location: `/${PATHS.CHANGE}`,
        },
        [PATHS.NOT_FOUND]: {
            id: PATHS.NOT_FOUND,
            path: `/${PATHS.NOT_FOUND}`,
            location: `/${PATHS.NOT_FOUND}`,
        },
        [PATHS.DASHBOARD]: {
            id: PATHS.DASHBOARD,
            path: `/${PATHS.DASHBOARD}`,
            location: `/${PATHS.DASHBOARD}`,
        },
        [PATHS.ADMIN]: {
            id: PATHS.ADMIN,
            path: `/${PATHS.ADMIN}`,
            location: `/${PATHS.ADMIN}`,
        },
        [PATHS.PROPERTY]: {
            id: PATHS.PROPERTY,
            path: `/${PATHS.PROPERTY}`,
            location: `/${PATHS.PROPERTY}`,
        },
        [PATHS.FACILITY]: {
            id: PATHS.FACILITY,
            path: `/${PATHS.FACILITY}`,
            location: `/${PATHS.FACILITY}`,
        },
        [PATHS.FINANCIAL]: {
            id: PATHS.FINANCIAL,
            path: `/${PATHS.FINANCIAL}`,
            location: `/${PATHS.FINANCIAL}`,
        },
        [PATHS.UICOMPONENTS]: {
            id: PATHS.UICOMPONENTS,
            path: `/${PATHS.UICOMPONENTS}`,
            location: `/${PATHS.UICOMPONENTS}`,
        },
        [PATHS.CLREQUESTS]: {
            id: PATHS.CLREQUESTS,
            path: `/${PATHS.CLREQUESTS}`,
            location: `/${PATHS.CLREQUESTS}`,
        },
        [PATHS.RFQS]: {
            id: PATHS.RFQS,
            path: `/${PATHS.RFQS}`,
            location: `/${PATHS.RFQS}`,
        },
        [PATHS.CLOFFERS]: {
            id: PATHS.CLOFFERS,
            path: `/${PATHS.CLOFFERS}`,
            location: `/${PATHS.CLOFFERS}`,
        },
        [PATHS.CLORDERS]: {
            id: PATHS.CLORDERS,
            path: `/${PATHS.CLORDERS}`,
            location: `/${PATHS.CLORDERS}`,
        },
        [PATHS.OFFERS]: {
            id: PATHS.OFFERS,
            path: `/${PATHS.OFFERS}`,
            location: `/${PATHS.OFFERS}`,
        },
        [PATHS.ORDERS]: {
            id: PATHS.ORDERS,
            path: `/${PATHS.ORDERS}`,
            location: `/${PATHS.ORDERS}`,
        },
        [PATHS.LEADS]: {
            id: PATHS.LEADS,
            path: `/${PATHS.LEADS}`,
            location: `/${PATHS.LEADS}`,
        },
        [PATHS.CLIENTS]: {
            id: PATHS.CLIENTS,
            path: `/${PATHS.CLIENTS}`,
            location: `/${PATHS.CLIENTS}`,
        },
        [PATHS.QUOTATIONS]: {
            id: PATHS.QUOTATIONS,
            path: `/${PATHS.QUOTATIONS}`,
            location: `/${PATHS.QUOTATIONS}`,
        },
        [PATHS.STOCK]: {
            id: PATHS.STOCK,
            path: `/${PATHS.STOCK}`,
            location: `/${PATHS.STOCK}`,
        }
    }
};

export const MAIN_PATHS = new Set([
    PATHS.DASHBOARD,
    PATHS.ADMIN,
    PATHS.RFQS
]);

export const LOCALIZATION_PATH = './localization';
export const ICONS_PATH = './global/ux/icons';

@Injectable({
    providedIn: 'root'
})

export class ValuesService {
    public readonly ICONS_PATH = ICONS_PATH;
}